import { type ElementType, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Wraps content in a one-shot CSS "appear" animation (subtle fade + rise).
 *
 * Pass `delay` (ms) to stagger several instances into a cascade. The animation
 * uses `both` fill so the element stays hidden during its delay instead of
 * flashing in first. Renders a <div> by default; use `as` to keep valid markup
 * (e.g. `as="li"` inside a <ul>).
 */
export function Appear({
  children,
  delay = 0,
  as,
  className,
}: {
  children: ReactNode
  delay?: number
  as?: ElementType
  className?: string
}) {
  const Comp = as ?? 'div'
  return (
    <Comp className={cn('animate-appear', className)} style={{ animationDelay: `${delay}ms` }}>
      {children}
    </Comp>
  )
}
